module.exports = __webpack_public_path__ + "f9f68103e64f74599a0e2fe0303371b0.svg";